import React from "react";
// import Register from "./Register";
import Footer from "./Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loginnavbar from "./Loginnavbar";
import RegisterMain from "./RegisterMain";

const Loginlayout = ({ children }) => {
  return (
    <div>
        <Loginnavbar/>
        {/* <Register/> */}
        <RegisterMain/>
        {children}
        <ToastContainer
  position='bottom-right'
  autoClose={5000}
  newestOnTop={true}
  closeOnClick
  pauseOnHover
  theme='colored'
  toastStyle={{ textAlign: 'left' }}  // Set text-align left
  fontSize="10px"
/>
        <Footer/>

    </div>
  );
};

export default Loginlayout;
